import React from "react";
import { createRoot } from "react-dom/client";
import "leaflet/dist/leaflet.css";
import "./styles.css";
import App from "./App";

createRoot(document.getElementById("root")).render(<App />);

// App instalable (PWA): el service worker solo se registra en el sitio publicado, no en desarrollo.
if ("serviceWorker" in navigator && process.env.NODE_ENV === "production") {
    window.addEventListener("load", () => { navigator.serviceWorker.register("/sw.js").catch(() => { /* sin service worker el sitio funciona igual */ }); });
}
